// A block that shows one part at a time hides its other parts' review highlights along
// with the parts. In review mode its Previous/Next buttons carry the sign instead: each
// is flagged while a part in its direction holds pending feedback (TMS-1632). The review
// canvas paints `.is-commented` on the part; outside review mode no part carries it, so
// this clears both flags and changes nothing.
export function flagCommentedNeighbours({ parts, currentIndex, previousButton, nextButton }) {
  const commentedIndexes = parts
    .map((part, index) => (part.classList.contains("is-commented") ? index : null))
    .filter((index) => index !== null)

  previousButton?.classList.toggle("has-commented-content", commentedIndexes.some((index) => index < currentIndex))
  nextButton?.classList.toggle("has-commented-content", commentedIndexes.some((index) => index > currentIndex))
}
